export const SET_DOCUMENT_TITLE = 'SET_DOCUMENT_TITLE' as const;
export const SET_META_TAGS = 'SET_META_TAGS' as const;
